import { render, staticRenderFns } from "./RobotsPanel.vue?vue&type=template&id=d8ae60a4&scoped=true"
import script from "./RobotsPanel.vue?vue&type=script&lang=js"
export * from "./RobotsPanel.vue?vue&type=script&lang=js"
import style0 from "./RobotsPanel.vue?vue&type=style&index=0&id=d8ae60a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ae60a4",
  null
  
)

export default component.exports